"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
/*
This file maps exports from `aws-amplify/analytics`. It provides access to the default Analytics provider and category
utils.
*/
tslib_1.__exportStar(require("@aws-amplify/analytics"), exports);
